module.exports = __webpack_public_path__ + "static/media/29ADMSPC18.ed2225c2.jpg";